// extracted by mini-css-extract-plugin
export default {"text":"render-text_text__AIHHr"};